<template>
  <div id="service-cart">
    <v-card class="service-cart" v-if="this.$store.state.user.service_cart.length > 0">
      <v-list three-line>
        <template v-for="(item, index) in selected_services">
          <v-list-tile v-if="item.card.title" class="py-2" :key="item.id" avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.service_info.title }}</v-list-tile-title>
              <v-list-tile-sub-title
                class="text--primary"
              >Estimate Cost: {{ format_money(item.service_info.estimate) }}</v-list-tile-sub-title>
              <v-list-tile-sub-title
                class="text--primary"
              >Retainer: {{ format_money(item.service_info.cost) }}</v-list-tile-sub-title>
              <v-list-tile-sub-title
                class="text--primary"
              >Service Fee: {{ format_money(item.service_info.service_fee) }}</v-list-tile-sub-title>
              <v-list-tile-sub-title class="text--primary">
                <strong>Total:</strong>
                {{ format_money(item.service_info.total) }}
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-list-tile-action-text>per {{item.service_info.rate}}</v-list-tile-action-text>
              <section>
                <v-icon
                  color="indigo darken-2"
                  class="service-edit"
                  @click="edit_item_from_cart(index, item)"
                >edit</v-icon>
                <v-icon
                  color="indigo darken-2"
                  class="service-remove"
                  @click="remove_item_from_cart(index, item)"
                >close</v-icon>
              </section>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider class="ma-0" v-if="index != selected_services.length-1" :key="index"></v-divider>
        </template>
        <modal
          :key="componentKey"
          :showModal="showModal"
          :serviceFilters="service_filters"
          :card="card"
          :updateService="updateService"
          v-if="service_filters"
        />
      </v-list>
    </v-card>
  </div>
</template>

<script>
import modal from "../components/service_modal";

export default {
  components: {
    modal
  },
  data() {
    return {
      componentKey: 0,
      card: null,
      showModal: false,
      service_filters: null,
      updateService: null
    };
  },
  methods: {
    format_money(value) {
      return "$" + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    remove_item_from_cart(index, item) {
      this.selected_services.splice(index, 1);
    },
    force_rerender() {
      this.componentKey += 1;
    },
    edit_item_from_cart(index, item) {
      this.force_rerender();

      if (this.showModal) {
        this.showModal = false;
      }
      this.showModal = true;

      this.$store
        .dispatch("handleModal", this.showModal)
        .then(() => {
          const service = item;
          this.updateService = service;

          this.card = service.card;
          this.service_filters = service.service_filters;
        })
        .catch(error => {
          this.showError(error);
        });
      const service = item;
      this.updateService = service;

      this.card = service.card;
      this.service_filters = service.service_filters;
    }
  },
  computed: {
    selected_services() {
      return this.$store.getters.getServiceCart;
    }
  }
};
</script>

<style scoped>
.service-edit {
  margin-right: 20px;
}
.service-cart {
  height: auto;
  margin-top: 15px;
  margin-bottom: 15px;
  overflow-y: scroll;
}
</style>

